
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'BudgetGauge' })
export default class extends Vue {
  @Prop({ required: true }) consumed!: number
  @Prop({ required: true }) reserve!: number
  @Prop({ required: true }) fallback!: number
  @Prop({ required: true }) budget!: number

  get scale(): number {
    return Math.max(this.budget, this.consumed + this.reserve, 1)
  }

  get segments(): { key: string; width: number }[] {
    const consumed = this.toWidth(this.consumed)
    const reserve = this.toWidth(this.reserve)
    const leftover = Math.max(0, 100 - consumed - reserve)
    const fallbackCap = this.toWidth(this.fallback)
    const fallback = Math.min(fallbackCap, leftover)
    const rest = Math.max(0, leftover - fallback)
    return [
      { key: 'consumed', width: consumed },
      { key: 'reserve', width: reserve },
      { key: 'fallback', width: fallback },
      { key: 'rest', width: rest }
    ].filter(segment => segment.width > 0)
  }

  get budgetMarker(): number {
    return (this.budget / this.scale) * 100
  }

  get legend() {
    return [
      { key: 'consumed', label: this.$t('cultureSubsidy.gauge.consumed'), value: this.consumed },
      { key: 'reserve', label: this.$t('cultureSubsidy.gauge.reserve'), value: this.reserve },
      { key: 'fallback', label: this.$t('cultureSubsidy.gauge.fallback'), value: this.fallback },
      { key: 'rest', label: this.$t('cultureSubsidy.gauge.budget'), value: this.budget }
    ]
  }

  get ariaLabel(): string {
    return String(this.$t('cultureSubsidy.gauge.aria', {
      consumed: this.consumed,
      reserve: this.reserve,
      fallback: this.fallback,
      budget: this.budget
    }))
  }

  toWidth(value: number): number {
    return Math.max(0, (value / this.scale) * 100)
  }
}
